import React from 'react';
import './WhyNetCup.css';

const WhyNetCup = () => {
  const reasons = [
    {
      title: 'Güvenli',
      description: 'Kalfa Elektrik Elektronik, tüm projelerinde güvenlik standartlarına uygun çalışarak güvenli ve güvenilir elektrik sistemleri kurar.'
    },
    {
      title: 'Kaliteli',
      description: 'Yüksek kaliteli malzeme ve ekipmanlar kullanarak, uzun ömürlü ve dayanıklı sistemler kuruyoruz.'
    },
    {
      title: 'Profesyonel',
      description: 'Uzman ekibimiz ve deneyimli teknisyenlerimiz ile her türlü elektrik ve elektronik ihtiyacınızı karşılıyoruz.'
    }
  ];

  return (
    <section id="why-netcup" className="why-netcup">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Neden Kalfa Elektrik Elektronik?</h2>
        </div>
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNetCup;
